/**
 * "เปิดแชทนี้ใน LINE OA" (owner 27 ก.ย. 69 — the old link opened "ไม่มีบัญชีนี้ หรือคุณไม่ได้รับสิทธิ์ใช้ฟังก์ชันแชท
 * ของบัญชีนี้"). LINE OA Manager (chat.line.biz) uses ids of its own, so the links come from what people paste
 * (api/app/line_oa.py): the owner pastes one chat.line.biz link per OA (ตั้งค่า › ช่องทางที่เชื่อม) → the logo opens the
 * OA's chat list and copies the customer's name for its search box; staff may paste the customer's own chat link once
 * (customer panel) → the logo opens that chat. Same checks as the server, so a wrong paste is told at once.
 * What the logo does: lib/platformChat.ts (shared with Messenger / Instagram).
 */
// exactly the shapes OA Manager shows in the address bar (anything else is refused, never repaired)
const OA_URL = /^https:\/\/chat\.line\.biz\/(U[0-9a-f]{32})(\/.*)?$/
const CHAT_URL = /^https:\/\/chat\.line\.biz\/(U[0-9a-f]{32})\/chat\/(U[0-9a-f]{32})(?:[/?#].*)?$/

export const SETUP_WHERE = 'ตั้งค่า › ช่องทางที่เชื่อม'
export const BAD_OA_URL =
  'ลิงก์ไม่ถูกต้อง · เปิด LINE OA ที่ chat.line.biz เลือกบัญชีนี้ แล้วคัดลอกลิงก์จากช่องที่อยู่ของเบราว์เซอร์มาวาง (ขึ้นต้นด้วย https://chat.line.biz/U…)'
export const BAD_CHAT_URL =
  'ลิงก์ไม่ถูกต้อง · เปิดแชทของลูกค้าคนนี้ใน LINE OA แล้วคัดลอกลิงก์จากช่องที่อยู่ของเบราว์เซอร์ (https://chat.line.biz/U…/chat/U…)'
export const LIST_NOT_CHAT = 'ลิงก์นี้เป็นหน้ารายการแชท · เปิดแชทของลูกค้าคนนี้ใน LINE OA ก่อน แล้วคัดลอกลิงก์อีกครั้ง'

/** Any chat.line.biz page of one OA → that OA's id. */
export function parseOaUrl(text: string): string | null {
  const m = OA_URL.exec(text.trim())
  return m ? m[1]! : null
}

/** A customer's chat page → [OA id, chat id]. */
export function parseChatUrl(text: string): [string, string] | null {
  const m = CHAT_URL.exec(text.trim())
  return m ? [m[1]!, m[2]!] : null
}

/** Thai reason a pasted customer link is refused before asking the server (null = looks right). */
export function chatUrlProblem(text: string, oaId: string | null): string | null {
  const got = parseChatUrl(text)
  if (!got) return parseOaUrl(text) ? LIST_NOT_CHAT : BAD_CHAT_URL
  if (oaId && got[0] !== oaId) return 'ลิงก์นี้เป็นแชทของ LINE OA บัญชีอื่น · เปิดแชทของลูกค้าคนนี้ใน OA ของร้านแล้วคัดลอกลิงก์ใหม่'
  return null
}

/** "https://chat.line.biz/U9835…c0de" — enough to recognise, short enough for one line. */
export function shortOaUrl(url: string): string {
  const m = /^https:\/\/chat\.line\.biz\/(U[0-9a-f]{32})/.exec(url)
  return m ? `chat.line.biz/${m[1]!.slice(0, 5)}…${m[1]!.slice(-4)}` : url
}
